export const TOGGLE_EDIT_CONTENT = 'TOGGLE_EDIT_CONTENT';

const initialState = {
  showSidebar: false,
  showAdminSidebar: false,
  showBasketDropdown: false,
  showSaveOrderDialog: false,
  showPersonalRewardsSettings: false,
  showPrivacyPopup: false,
  showMarketingConsentPopup: false,
  isUser: false,
  isAdmin: false,
  editContent: false,
  loaded: false,
  lockScroll: false,
  requestedPath: null,
  profile: {attributes:{}},
  profileMeta: {"outlets-without-vouchers": []},
};

export default function viewReducer(state = initialState, action) {
  switch (action.type) {
    case 'CURRENT_USER_PROFILE_FULFILLED': {
      const isAdmin = action.payLoad.data.attributes.permissions.can.login.indexOf('admin_portal') !== -1;
      const isUser = action.payLoad.data.attributes.permissions.can.login.indexOf('web_app') !== -1;
      const showAdminSidebar = isAdmin && state.showSidebar;

      return {
        ...state,
        profile: action.payLoad.data,
        profileMeta: action.payLoad.meta,
        isAdmin: isAdmin,
        isUser: isUser,
        showAdminSidebar: showAdminSidebar,
        loaded: true,
      }
    }
    case 'SET_VIEWCONFIG_LOADED': {
      return {
        ...state,
        loaded: true,
      }
    }
    case 'CLEAR_PROFILE': {
      return {
        ...state,
        profile: initialState.profile,
        profileMeta: initialState.profileMeta,
        is_admin: false,
      }
    }
    case 'LOCK_SCROLL': {
      return {
        ...state,
        lockScroll: true
      }
    }
    case 'UNLOCK_SCROLL': {
      return {
        ...state,
        lockScroll: false
      }
    }
    case 'TOGGLE_BASKET_DROPDOWN': {
      return {
        ...state,
        showBasketDropdown: !state.showBasketDropdown
      }
    }
    case 'TOGGLE_SAVE_ORDER_DIALOG': {
      return {
        ...state,
        showBasketDropdown: false,
        showSaveOrderDialog: !state.showSaveOrderDialog
      }
    }
    case 'TOGGLE_PERSONAL_REWARDS_SETTINGS_DIALOG': {
      return {
        ...state,
        showPersonalRewardsSettings: action.payLoad
      }
    }
    case TOGGLE_EDIT_CONTENT: {
      return {
        ...state,
        editContent: action.payLoad === undefined ? !state.editContent : action.payLoad
      }
    }
    case 'TOGGLE_PRIVACY_MODAL': {
      return {
        ...state,
        showPrivacyPopup: action.payLoad,
      }
    }
    case 'TOGGLE_MARKETING_MODAL': {
      return {
        ...state,
        showMarketingConsentPopup: action.payLoad,
      }
    }
    case 'SAVE_REQUESTED_PATH': {
      return {
        ...state,
        requestedPath: action.payLoad
      }
    }
    case 'CLEAR_REQUESTED_PATH': {
      return {
        ...state,
        requestedPath: null
      }
    }
    case 'SET_DEFAULT_STORE_FULFILLED': {
      const { profile } = state;
      const { attributes } = profile;

      return {
        ...state,
        profile: {
          ...profile,
          attributes: { ...attributes, 'default-outlet-id': action.payload.storeId }
        }
      }
    }
    default:
  }

  return {...state};
}



// WEBPACK FOOTER //
// ./src/reducers/viewReducer.js